
import {
  defineComponent,
  PropType,
  ref,
  watch,
  onMounted,
} from 'vue';
import { useI18n } from 'vue-i18n';
import {
  FieldConfig,
  ParserFieldObject,
  Property,
} from '@/types';

export default defineComponent({
  name: 'WheelDisplayModeField',

  props: {
    configs: {
      type: Object as PropType<FieldConfig>,
      required: true,
    },

    parserValues: {
      type: Object as PropType<ParserFieldObject>,
      required: true,
    },
  },

  emits: ['on-change-properties'],

  setup(props, { emit }) {
    const { t } = useI18n();
    const property = ref<Property>(props.parserValues.properties[0]);
    const selectedMode = ref<string>('full');

    const displayModes = [
      { value: 'full', label: 'templateBuilder.games.wheelDisplayMode.full' },
      { value: 'top', label: 'templateBuilder.games.wheelDisplayMode.top' },
      { value: 'bottom', label: 'templateBuilder.games.wheelDisplayMode.bottom' },
      { value: 'left', label: 'templateBuilder.games.wheelDisplayMode.left' },
      { value: 'right', label: 'templateBuilder.games.wheelDisplayMode.right' },
    ];

    const parseInitialValue = () => {
      const value = property.value.value;
      if (value && typeof value === 'string' && displayModes.some(m => m.value === value)) {
        selectedMode.value = value;
      } else {
        selectedMode.value = 'full';
      }
    };

    const emitChange = () => {
      property.value.value = selectedMode.value;
      emit('on-change-properties', {
        selector: props.parserValues.selector,
        properties: [property.value],
      });
    };

    const selectMode = (mode: string) => {
      selectedMode.value = mode;
      emitChange();
    };

    onMounted(() => {
      parseInitialValue();
    });

    watch(() => props.parserValues.properties[0]?.value, () => {
      parseInitialValue();
    }, { deep: true });

    return {
      t,
      selectedMode,
      displayModes,
      selectMode,
    };
  },
});
